import React, { useState, useEffect } from "react";
import Select from "@atlaskit/select";
import { useDispatch, useSelector } from "react-redux";

const FlowSelectList = ({ callback, isCompact }) => {
  const [value, setValue] = useState("");
  const [options, setOptions] = useState([]);

  const flows = useSelector((state) => state.integration.flows);

  useEffect(() => {
    if (flows) {
      setOptions(
        flows.map((f) => {
          return { label: f.name, value: f.id };
        })
      );
    }
  }, [flows]);
  const onChange = (flow) => {
    setValue(flow);
    callback(flow.value);
  };
  return (
    <Select
      spacing={isCompact ? "compact" : "default"}
      inputId="flows"
      className="hub-flows"
      options={options}
      value={value}
      placeholder="Choose integration"
      onChange={onChange}
    />
  );
};
export default FlowSelectList;
